import { render, staticRenderFns } from "./YourTrialHasExpired.vue?vue&type=template&id=059c6152&scoped=true&"
import script from "./YourTrialHasExpired.vue?vue&type=script&lang=ts&"
export * from "./YourTrialHasExpired.vue?vue&type=script&lang=ts&"
import style0 from "./YourTrialHasExpired.vue?vue&type=style&index=0&id=059c6152&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059c6152",
  null
  
)

export default component.exports